//#region IMPORTS
import { setInstoreTypePageNumber } from "../../features/instoreTypes/instoreTypesSlice";
import { useAppDispatch } from "../../store/configureStore";
import { InstoreType } from "../../models/instoreType";
import { MetaData } from "../../models/pagination";
import InstoreTypesTableHeader from "./InstoreTypesTableHeader";
import InstoreTypesTableRow from "./InstoreTypesTableRow";
import MainTable from "../_layout/MainTable";
//#endregion

//#region INTERFACE
interface Props {
  deleteHandler: (item: InstoreType) => void;
  editHandler: (item: InstoreType) => void;
  itemsLoaded: boolean;
  metaData?: MetaData;
  loading?: boolean;
  items: InstoreType[];
  hide?: boolean;
}
//#endregion

export default function InstoreTypesTable({
  deleteHandler,
  editHandler,
  itemsLoaded,
  metaData,
  loading = false,
  items,
  hide = false,
}: Props) {
  //#region SETUP
  // Redux
  const dispatch = useAppDispatch();
  //#endregion

  //#region RENDER
  return (
    <MainTable
      onPageChangeHandler={(page: number) =>
        dispatch(setInstoreTypePageNumber({ page: page }))
      }
      itemsLoaded={itemsLoaded}
      metaData={metaData}
      header={<InstoreTypesTableHeader />}
      hide={hide}
    >
      {items.map((instoreType) => (
        <InstoreTypesTableRow
          deleteHandler={() => deleteHandler(instoreType)}
          editHandler={() => editHandler(instoreType)}
          instoreType={instoreType}
          loading={loading}
          key={instoreType.id}
        />
      ))}
    </MainTable>
  );
  //#endregion
}
